function initLandingMenu() {
	const toggle = document.getElementById("landingMenuToggle");
	const closeButton = document.getElementById("landingMenuClose");
	const panel = document.getElementById("landingMenu");
	const overlay = document.getElementById("landingMenuOverlay");
	const body = document.body;
  
	if (!toggle || !closeButton || !panel || !overlay) return;
  
	function openMenu() {
	  panel.classList.add("is-open");
	  overlay.classList.add("is-open");
	  body.classList.add("menu-open");
  
	  panel.setAttribute("aria-hidden", "false");
	  toggle.setAttribute("aria-expanded", "true");
	}
  
	function closeMenu() {
	  panel.classList.remove("is-open");
	  overlay.classList.remove("is-open");
	  body.classList.remove("menu-open");
  
	  panel.setAttribute("aria-hidden", "true");
	  toggle.setAttribute("aria-expanded", "false");
	}
  
	toggle.onclick = openMenu;
	closeButton.onclick = closeMenu;
	overlay.onclick = closeMenu;
  
	panel.querySelectorAll("a").forEach((link) => {
	  link.onclick = closeMenu;
	});
  
	document.onkeydown = function (event) {
	  if (event.key === "Escape") {
		closeMenu();
	  }
	};
  }
  
  document.addEventListener("turbolinks:load", initLandingMenu);
  document.addEventListener("DOMContentLoaded", initLandingMenu);